export default __webpack_public_path__ + "static/media/ambulance.8f075a5d.png";